import { useMemo, useState } from "react";
import { articles, categories } from "@/mocks/content";
import SectionHeading from "./SectionHeading";

export default function ContentStream() {
  const [active, setActive] = useState("all");

  const list = useMemo(
    () => (active === "all" ? articles : articles.filter((a) => a.category === active)),
    [active]
  );

  return (
    <section id="columns" className="scroll-mt-16 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          index="02"
          eyebrow="Columns"
          title="深度栏目"
          desc="内幕、真相、线索与解析四大栏目并行。切换分类即可按需浏览，头条深读与关系图谱另有独立版面。"
        />

        <div className="mb-7 flex flex-wrap items-center gap-1 rounded-full border border-background-300 bg-background-50 p-1 w-fit">
          {categories.map((c) => (
            <button
              key={c.key}
              type="button"
              onClick={() => setActive(c.key)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                active === c.key
                  ? "bg-foreground-950 text-background-50"
                  : "text-foreground-600 hover:bg-background-200 hover:text-foreground-950"
              }`}
            >
              {c.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((a) => (
            <article
              key={a.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="relative aspect-[4/3] w-full overflow-hidden bg-background-200">
                <img
                  src={a.image}
                  alt={`${a.title} 选题封面`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded bg-foreground-950/85 px-2.5 py-1 text-xs font-medium text-background-100 backdrop-blur">
                  {a.categoryName}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <div className="mb-2 flex items-center gap-2 text-xs text-foreground-500">
                  <span className="rounded bg-accent-100 px-1.5 py-0.5 text-accent-900">{a.tag}</span>
                  <span>{a.time}</span>
                  <span className="ml-auto flex items-center gap-1">
                    <i className="ri-time-line" />
                    {a.readMinutes} 分钟
                  </span>
                </div>
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950">
                  {a.title}
                </h3>
                <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{a.excerpt}</p>
                <p className="mt-3 flex items-center gap-1.5 text-xs text-foreground-500">
                  <i className="ri-user-line" />
                  {a.author}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}